import type { PagedModelClientPersonReference } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useGrapevineGroupApi } from '@/features/api/hooks/grapevine-group/useGrapevineGroupApi';
import { useAuth } from '@/features/authorization/provider/useAuth';

export const useGetAllGroupMembers = (groupId: string) => {
  const { isAuthenticated } = useAuth();
  const api = useGrapevineGroupApi();

  const select = useCallback(
    (response: PagedModelClientPersonReference) => response.content,
    []
  );

  return useQuery({
    queryKey: [API_CACHE_KEYS.GROUP_MEMBERS, groupId, 'all'],
    queryFn: () => api.getAllMembersByGroupId({ groupId, count: 10_000 }),
    select,
    enabled: isAuthenticated
  });
};
